import { render, staticRenderFns } from "./PurchaseRow.vue?vue&type=template&id=87b96ec4&scoped=true&"
import script from "./PurchaseRow.vue?vue&type=script&lang=js&"
export * from "./PurchaseRow.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRow.vue?vue&type=style&index=0&id=87b96ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b96ec4",
  null
  
)

export default component.exports